// Tiny "Founder" pill shown next to author names on public/community cards.
// Only rendered when the backend flags a lecture's author as a Lectura founder
// (see FOUNDER_EMAILS + _backfill_authors in backend/server.py).
import { Crown } from "lucide-react";

export const FounderBadge = ({ className = "", size = "sm" }) => {
  const px = size === "sm" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-1 text-[10px]";
  const icon = size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3";
  return (
    <span
      data-testid="founder-badge"
      title="Lectura Founder — the person who built this app"
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-400 via-rose-500 to-fuchsia-600 text-white font-black uppercase tracking-widest shadow-sm ${px} ${className}`}
    >
      <Crown className={icon} /> Founder
    </span>
  );
};

export default FounderBadge;
